import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _defineProperty from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import Hamburger from '@/components/Hamburger';
import Screenfull from '@/components/Screenfull';
import { getZoneId, getUserUID, getUserPermission } from "../../utils/auth";
import { message_box_confirm } from '@/utils/constants';
export default {
  components: {
    Hamburger: Hamburger,
    Screenfull: Screenfull
  },
  data: function data() {
    return {
      timerCount: Date.now(),
      waitDialogVisible: false,
      user_avatar: ''
    };
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'avatar', 'device', 'getMyAvatar']), {
    myUser: function myUser() {
      return this.$store.getters.myUser;
    }
  }),
  watch: {
    $data: {
      immediate: true,
      handler: function handler() {
        var _this = this;

        setInterval(
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.realtimePermission();

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })), 30000);
      }
    }
  },
  beforeMount: function beforeMount() {
    // / 自分のアバターを取る
    this.$store.dispatch('getMyAvatarAction');
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getZoneId();

            case 2:
              _context2.t0 = _context2.sent;

              if (!(_context2.t0 === 'no-claim')) {
                _context2.next = 8;
                break;
              }

              _context2.next = 6;
              return this.$store.dispatch('user/logout');

            case 6:
              this.$router.push("/login?redirect=".concat(this.$route.fullPath));
              console.log('error, because dont have claim in token');

            case 8:
              _context2.next = 10;
              return this.$store.dispatch('profile/getMyUser');

            case 10:
              if (this.myUser) {
                user = this.myUser;

                if (user.avatar_thumbnail) {
                  this.user_avatar = user.avatar_thumbnail;
                } else {
                  this.user_avatar = 'parson_no-image.png';
                }
              }

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    checkUserPermission: function () {
      var _checkUserPermission = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var allAdminPermission, user_id, oldRole, newRole, newMapJson, oldMapJson;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                allAdminPermission = ['admin_bulletin_add', 'admin_bulletin_category_edit', 'admin_bulletin_edit', 'admin_bulletin_view', 'admin_role_add', 'admin_role_edit', 'admin_role_view', 'admin_user_add', 'admin_user_edit', 'admin_user_import', 'admin_user_view', 'get_can_use_admin_site', 'admin_suggestion_view', 'admin_suggestion_category_edit'];
                _context3.next = 3;
                return getUserUID();

              case 3:
                user_id = _context3.sent;
                _context3.next = 6;
                return getUserPermission();

              case 6:
                oldRole = _context3.sent;
                _context3.next = 9;
                return this.$store.dispatch('user/getUserRealTime', user_id);

              case 9:
                newRole = _context3.sent;

                if (!(newRole && oldRole)) {
                  _context3.next = 15;
                  break;
                }

                if (!newRole.role) {
                  _context3.next = 15;
                  break;
                }

                newMapJson = JSON.parse(JSON.stringify(newRole.role));
                oldMapJson = JSON.parse(oldRole);
                return _context3.abrupt("return", allAdminPermission.some(function (role) {
                  return oldMapJson[role] !== newMapJson[role];
                }));

              case 15:
                return _context3.abrupt("return", false);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function checkUserPermission() {
        return _checkUserPermission.apply(this, arguments);
      }

      return checkUserPermission;
    }(),
    realtimePermission: function () {
      var _realtimePermission = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.$router.history.current.name) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 3;
                return this.checkUserPermission();

              case 3:
                if (!_context5.sent) {
                  _context5.next = 6;
                  break;
                }

                this.waitDialogVisible = true;
                setTimeout(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee4() {
                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return _this2.$store.dispatch('user/logout');

                        case 2:
                          _this2.$router.push("/login?redirect=".concat(_this2.$route.fullPath));

                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                })), 6000);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function realtimePermission() {
        return _realtimePermission.apply(this, arguments);
      }

      return realtimePermission;
    }(),
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function () {
      var _logout = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6() {
        var result;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return message_box_confirm('確認', 'ログアウトしますか?', 'ログアウト', 'message_logout');

              case 2:
                result = _context6.sent;

                if (!result) {
                  _context6.next = 7;
                  break;
                }

                _context6.next = 6;
                return this.$store.dispatch('user/logout');

              case 6:
                this.$router.push("/login?redirect=".concat(this.$route.fullPath));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }
};